import React from 'react'
import PropTypes from 'prop-types'
import ImageGallery from '@codecraftkit/image-gallery'
import { MdAddBox } from 'react-icons/md'
import { ProfilePictureConfirmAvatarAlert } from '../ProfilePictureConfirmAvatarAlert'

/**
 * The gallery of avatars to pick from.
 *
 * # `react-custom-scroll` is gone
 *
 * It was used for one prop —`heightRelativeToParent="100%"`, i.e. height plus overflow— and in
 * exchange added four wrapper divs, ~11.6KB of JS and a stylesheet that does NOT ship with it:
 * the app pulled `customScroll.css` from a `<link>` to unpkg.com at a different version than the
 * installed JS. Five packages have now dropped it for the same reason.
 *
 * `overscroll-contain` is not decoration: the package blocked scroll chaining by default, so
 * without it the page scrolls behind the open modal as soon as the gallery hits its end.
 */
export const ProfilePictureChooseAvatar = ({
  item, onCloseModal, callback, avatars, getImageLoading, chooseAvatarAction, getImage,
  closeModalOnSubmit, isRounded, disableAgencyIcon, imagesGap, size
}) => {
  const [loading, setLoading] = React.useState(false)

  const updateImg = async img => {
    getImage?.(img)
    chooseAvatarAction?.(img, { setLoading, onCloseModal, callback, item })
    if (closeModalOnSubmit) onCloseModal?.()
  }

  return (
    <div className='h-[70vh] overflow-y-auto overscroll-contain [scrollbar-width:thin] [scrollbar-color:#cccccc_transparent]'>
      <div className='me-4'>
        <ImageGallery
          size={size || '130px'}
          imagesGap={imagesGap}
          images={avatars}
          loading={getImageLoading}
          groupByCategories
          sectionLabelField='category'
          noBorder
          roundImages={isRounded}
          imageIcon={MdAddBox}
          hoverClassName='hover:bg-black/50'
          roundedHover={isRounded}
          disableAgencyIcon={disableAgencyIcon}
          previewImageComponent={({ image, onClose }) => (
            /*
              * `item`, not `user`. The alert destructures `item` to read `item?.username`, and
              * the prop was called `user` — so it was always undefined and the avatar never fell
              * back to initials.
              */
            <ProfilePictureConfirmAvatarAlert
              loading={loading}
              onClose={onClose}
              item={item}
              avatarSelected={image}
              updateImg={updateImg}
            />
          )}
        />
      </div>
    </div>
  )
}

ProfilePictureChooseAvatar.propTypes = {
  item: PropTypes.object,
  onCloseModal: PropTypes.func,
  callback: PropTypes.func,
  avatars: PropTypes.array,
  getImageLoading: PropTypes.bool,
  chooseAvatarAction: PropTypes.func,
  getImage: PropTypes.func,
  closeModalOnSubmit: PropTypes.bool,
  isRounded: PropTypes.bool,
  disableAgencyIcon: PropTypes.bool,
  imagesGap: PropTypes.string,
  size: PropTypes.string
}
